import React from 'react';
import { GraduationCap } from 'lucide-react';
import { Container } from './Container';
import { UniversitySelector } from '../UniversitySelector';
import { useUniversity } from '../../contexts/UniversityContext';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  mode: 'semester' | 'quick';
  setMode: (mode: 'semester' | 'quick') => void;
}

export function Header({ mode, setMode }: HeaderProps) {
  const { selectedUniversity } = useUniversity();
  const navigate = useNavigate();

  const handleModeChange = (newMode: 'semester' | 'quick') => {
    setMode(newMode);
    navigate(newMode === 'semester' ? '/semester' : '/quick', { replace: true });
  };

  return (
    <header className="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 text-white py-4 md:py-6">
      <Container>
        <div className="md:hidden flex flex-col space-y-4">
          <div className="flex flex-col items-center space-y-2">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white/10 rounded-lg border border-white/20">
                <GraduationCap size={28} className="text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold">GPA Calculator</h1>
                <p className="text-sm text-blue-100">Track your academic progress</p>
              </div>
            </div>
            <div className="w-full max-w-xs">
              <UniversitySelector />
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <button
              onClick={() => handleModeChange('semester')}
              className={`px-6 py-2.5 rounded-lg text-sm font-medium transition-all
                ${mode === 'semester'
                  ? 'bg-white text-blue-600 shadow-md'
                  : 'bg-blue-500/20 text-white hover:bg-blue-500/30'}`}
            >
              Semester Mode
            </button>
            <button
              onClick={() => handleModeChange('quick')}
              className={`px-6 py-2.5 rounded-lg text-sm font-medium transition-all
                ${mode === 'quick'
                  ? 'bg-white text-blue-600 shadow-md'
                  : 'bg-blue-500/20 text-white hover:bg-blue-500/30'}`}
            >
              Quick Calculate
            </button>
          </div>
        </div>

        <div className="hidden md:flex items-center justify-between">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-white/10 rounded-lg border border-white/20">
                <GraduationCap size={32} className="text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-bold tracking-tight">GPA Calculator</h1>
                <p className="text-blue-100 mt-1">Track your academic progress with ease</p>
              </div>
            </div>
            <div className="w-64">
              <UniversitySelector />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => handleModeChange('semester')}
              className={`px-6 py-3 rounded-lg font-medium transition-all
                ${mode === 'semester'
                  ? 'bg-white text-blue-600 shadow-lg hover:shadow-xl'
                  : 'bg-blue-500/20 text-white hover:bg-blue-500/30'}`}
            >
              Semester Mode
            </button>
            <button
              onClick={() => handleModeChange('quick')}
              className={`px-6 py-3 rounded-lg font-medium transition-all
                ${mode === 'quick'
                  ? 'bg-white text-blue-600 shadow-lg hover:shadow-xl'
                  : 'bg-blue-500/20 text-white hover:bg-blue-500/30'}`}
            >
              Quick Calculate
            </button>
          </div>
        </div>
      </Container>
    </header>
  );
}